import React from 'react';
import { howItWorksSteps } from '../mock/mockData';
import { CheckCircle2 } from 'lucide-react';
import { psychologistInfo } from '../mock/mockData';

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-rose-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 border-2 border-rose-300 rounded-full"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 border-2 border-gold-300 rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-rose-900 mb-4">
            Como Funciona
          </h2>
          <p className="text-lg text-gray-600">
            O processo terapêutico é simples e estruturado para o seu conforto e bem-estar.
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {howItWorksSteps.map((step, index) => (
              <div
                key={step.id}
                className="relative group"
                style={{
                  animationDelay: `${index * 150}ms`
                }}
              >
                {/* Connecting line for desktop */}
                {index < howItWorksSteps.length - 1 && index % 2 === 0 && (
                  <div className="hidden md:block absolute top-1/2 left-full w-full h-0.5 bg-gradient-to-r from-rose-300 to-transparent transform -translate-y-1/2 z-0"></div>
                )}

                <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-rose-100 hover:border-rose-300 relative z-10 h-full group-hover:-translate-y-1">
                  {/* Step Number */}
                  <div className="flex items-start gap-4 mb-4">
                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-rose-500 to-rose-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold text-white">{step.step}</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-rose-800 mb-3 group-hover:text-rose-600 transition-colors">
                        {step.title}
                      </h3>
                    </div>
                  </div>

                  <p className="text-gray-600 leading-relaxed pl-20">
                    {step.description}
                  </p>

                  {/* Checkmark decoration */}
                  <div className="absolute top-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <CheckCircle2 className="h-6 w-6 text-rose-500" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            Pronta para iniciar a sua jornada de autoconhecimento e bem-estar?
          </p>
          <button
            onClick={() => window.open(psychologistInfo.bookingLink, '_blank')}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-rose-500 to-rose-600 hover:from-rose-600 hover:to-rose-700 text-white rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            Agende a Sua Consulta
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
